import * as React from "react";
import { useState } from "react";
import { IconPlus } from "@velaro/velaro-component-lib";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import TriggerModal from "./TriggerModal";
import useApi from "@/hooks/useApi";

export default function NewWorkflowButton() {
  const navigate = useNavigate();
  const api = useApi();
  const [showTriggerModal, setShowTriggerModal] = useState(false);

  async function selectTrigger(triggerId: string) {
    setShowTriggerModal(false);
    //persist a new workflow
    const response = await api.messaging.post("Workflows", {
      trigger: triggerId
    });
    const workflowId = await response.json();
    //navigate to workflows/id
    navigate(`/workflows/${workflowId}`);
  }

  return (
    <>
      <PrimaryBlueButton
        prefixIcon={<IconPlus />}
        onClick={() => selectTrigger("conversation_opened")}
        label="Create Workflow"
      />
      {showTriggerModal && (
        <TriggerModal
          onSelect={selectTrigger}
          onClose={() => setShowTriggerModal(false)}
        />
      )}
    </>
  );
}
